import { jsx as _jsx } from "react/jsx-runtime";
import { NavTabs } from '../../../../components/nav-tabs';
export function TopNavigation(param) {
    let { navigationItems } = param;
    if (!navigationItems.length) return null;
    const tabItems = navigationItems.map((item)=>{
        var _item_link;
        return {
            id: item.id,
            title: item.title,
            to: (_item_link = item.link) !== null && _item_link !== void 0 ? _item_link : item.path,
            exact: item.exact,
            includeSearch: item.includeSearch,
            activeBasePath: item.activeBasePath
        };
    });
    return /*#__PURE__*/ _jsx(NavTabs, {
        items: tabItems,
        "data-e2e": "LAYOUT_NAVIGATION_MENU"
    });
}
